export const API_SUCCESS_MESSAGE = "保存が完了しました。";
export const API_DELETE_SUCCESS_MESSAGE = "削除が完了しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const PREVENT_URL = "不適切なURLです";
export const DEFAULT_TIMER = 500;
export const VALIDATE_DEBOUNCE_DELAY = 1000;
export const MAX_INTEGER = 2147483646;
export const CACHED_TIME = 10000;
export const MAXIMUM_NUMBER_VALIDATION = 9999999999999;
export const RSO_SUPPORT_FEE_MAXIMUM_NUMBER = 99999999;
export const MAX_SPECIFIC_SKILL_TRANSITION_MONTH_PERIOD = 0;
export const MAX_SPECIFIC_SKILL_TRANSITION_YEAR_PERIOD = 5;
export const ZIP_CODE_DEBOUNCE_DELAY = 100;
export const JWT_REGEX = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/;
